import React, { forwardRef } from 'react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className = '',
  error,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-7015">
        <input ref={ref} className={`w-full px-3 py-2 border rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${error ? 'border-red-300 focus:ring-red-500' : 'border-gray-300 hover:border-gray-400'} ${className}`} {...props} data-id="element-7016" />
        {error && <p className="mt-1 text-xs text-red-500" data-id="element-7017">{error}</p>}
      </div>;
});
Input.displayName = 'Input';